import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import "./Nav.css";
import logo from "../Assets/logo.png";

const Nav = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Handle navbar visibility on scroll
  const handleScroll = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > lastScrollY && currentScrollY > 50) {
      // Scrolling down, hide navbar
      setIsVisible(false);
    } else {
      // Scrolling up, show navbar
      setIsVisible(true);
    }
    setLastScrollY(currentScrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <nav className={`nav ${isVisible ? "visible" : "hidden"}`}>
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/">
            <img src={logo} alt="Logo" className="logo-img" />
          </Link>
        </div>
        <div className={`navbar-links ${menuOpen ? "open" : ""}`}>
          <Link to="/about_us" onClick={closeMenu}>
            AboutUs
          </Link>
          <a href="mailto:jesse@lindstaedt.com" onClick={closeMenu}>
            Contact
          </a>
          <Link to="/early_access" onClick={closeMenu}>Early Access</Link>
        </div>
        <div className="navbar-icon" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </nav>
  );
};

export default Nav;
